<mat-spinner class="loading"></mat-spinner>
<div class="loading__text">{{ translateKeyToDisplay | translate }}</div>